export const rpReportDefinitionsKey = 'rp-report-definitions-key';
export const rpReportAnswerKey = 'rp-report-answer-key';
export const rpReportGroupsKey = 'rp-report-groups-key';
export const rpReportGroupByNameKey = 'rp-report-group-name-key';
export const rpInspectionReportDataNameKey = 'rp-inspection-report-data-key';
export const rpReportKey = 'rp-report-key';
export const rpReportsKey = 'rp-reports-key';
